"use client";

import { CategoryDto } from "@/__generated__/sdk";
import InfoCircleIcon from "@/app/_components/Icons/InfoCircleIcon";
import { Close } from "@mui/icons-material";
import { Box, Button, DialogContent, DialogTitle, Icon, IconButton, Stack, SwipeableDrawer, Typography } from "@mui/material";
import DOMPurify from "isomorphic-dompurify";
import React from "react";

type Props = {
  category: CategoryDto;
};
export default function CategoryGuide({ category }: Props) {
  const hasGuide = Boolean(category.guideTitle && category.guideContent);
  const [open, setOpen] = React.useState(false);
  if (!hasGuide) {
    return <></>;
  }

  return (
    <>
      <Button
        onClick={() => {
          setOpen((e) => !e);
        }}
        sx={{
          borderRadius: 150,
          backgroundColor: { md: "info.50", xs: "unset" },
          pr: 1.5,
        }}
        color="info"
        size="small"
        disableElevation
        variant="text"
        startIcon={
          <Icon fontSize="small">
            <InfoCircleIcon />
          </Icon>
        }
      >
        {category.guideTitle}
      </Button>

      <SwipeableDrawer
        PaperProps={{
          sx: (theme) => ({
            mx: "auto",
            width: {
              xs: "100%",
              sm: "100%",
              md: theme.breakpoints.values.md,
              lg: theme.breakpoints.values.lg,
              //   xl: theme.breakpoints.values.xl,
            },
          }),
        }}
        ModalProps={{
          keepMounted: false,
          slotProps: {},
          sx: {
            "& .MuiPaper-root": {
              height: "85%",
              borderTopLeftRadius: 4 * 4,
              borderTopRightRadius: 4 * 4,
            },
          },
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <DialogTitle component={"div"} sx={{ p: 0 }}>
          <Stack>
            <Stack direction={"row"} sx={{ mt: 1 }} alignItems={"center"} justifyContent={"center"}>
              <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
            </Stack>
            <Stack>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
                <Typography variant="h5">{category.guideTitle}</Typography>
                <IconButton
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <Close />
                </IconButton>
              </Box>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ p: 0, px: 1.5 }}>
          {category.guideContent && (
            <Stack>
              {/* <Typography component="div" whiteSpace="pre-wrap"> */}
              <div
                className="ck-content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(category.guideContent, {
                    ADD_TAGS: ["iframe"],
                    ADD_ATTR: ["src", "webkitallowfullscreen", "mozallowfullscreen", "allowfullscreen"],
                  }),
                }}
              ></div>
              {/* </Typography> */}
            </Stack>
          )}
        </DialogContent>
      </SwipeableDrawer>
    </>
  );
}
